export default (template, vars) => {
  let compiledTemplate = template;

  Object.keys(vars).forEach(varKey => {
    compiledTemplate = compiledTemplate.replace(
      '${' + varKey + '}',
      vars[varKey]
    );
  });

  return compiledTemplate;
};
